export default __webpack_public_path__ + "static/media/odpri_okno_koledarja.bce27e67.mp3";